<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g opacity="0.5">
      <path
        d="M18.666 4V9.33333C18.666 9.68695 18.8065 10.0261 19.0565 10.2761C19.3066 10.5262 19.6457 10.6667 19.9993 10.6667H25.3327"
        stroke="currentColor"
        stroke-width="1.744"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33268 28H22.666C23.3733 28 24.0515 27.719 24.5516 27.219C25.0517 26.7189 25.3327 26.0406 25.3327 25.3333V10.6667L18.666 4H9.33268C8.62544 4 7.94716 4.28095 7.44706 4.78105C6.94697 5.28115 6.66602 5.95942 6.66602 6.66667V25.3333C6.66602 26.0406 6.94697 26.7189 7.44706 27.219C7.94716 27.719 8.62544 28 9.33268 28Z"
        stroke="currentColor"
        stroke-width="1.744"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6667 20.0002C14.6667 20.177 14.7369 20.3465 14.8619 20.4716C14.987 20.5966 15.1565 20.6668 15.3333 20.6668H16.6667C16.8435 20.6668 17.013 20.5966 17.1381 20.4716C17.2631 20.3465 17.3333 20.177 17.3333 20.0002V18.6668C17.3333 18.49 17.2631 18.3204 17.1381 18.1954C17.013 18.0704 16.8435 18.0002 16.6667 18.0002H15.3333C15.1565 18.0002 14.987 17.9299 14.8619 17.8049C14.7369 17.6799 14.6667 17.5103 14.6667 17.3335V16.0002C14.6667 15.8234 14.7369 15.6538 14.8619 15.5288C14.987 15.4037 15.1565 15.3335 15.3333 15.3335H16.6667C16.8435 15.3335 17.013 15.4037 17.1381 15.5288C17.2631 15.6538 17.3333 15.8234 17.3333 16.0002M19.3333 15.3335L20.6667 20.6668L22 15.3335M12.6667 16.6668C12.6667 16.3132 12.5262 15.9741 12.2761 15.724C12.0261 15.474 11.687 15.3335 11.3333 15.3335C10.9797 15.3335 10.6406 15.474 10.3905 15.724C10.1405 15.9741 10 16.3132 10 16.6668V19.3335C10 19.6871 10.1405 20.0263 10.3905 20.2763C10.6406 20.5264 10.9797 20.6668 11.3333 20.6668C11.687 20.6668 12.0261 20.5264 12.2761 20.2763C12.5262 20.0263 12.6667 19.6871 12.6667 19.3335"
        stroke="currentColor"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
